import React from "react";
import { ShortTitleComp } from "../../../product/components/ShortTitle";
import { ItemWrap } from "./IdeaSection";

import { MAX_TITLE_CHARACTERS } from '../../../../variable';

const label = "AMZ Title";
export function AMZTitle({ canEdit, value, onChange }) {
    return canEdit ? (
        <ShortTitleComp
            value={value}
            onChange={onChange}
            label={label}
            maxLength={MAX_TITLE_CHARACTERS.amzTitle}
            placeholder="amazon title"
            id="amzTitle"
        />
    ) : (
        <ItemWrap label={label}>
            <span title={value}>{value}</span>
        </ItemWrap>
    );
}
